import React, { useEffect } from 'react';
import {
  Box, Button, ButtonVariant, Text,
} from '@usealloy/component-library';
import type { FallbackProps } from 'react-error-boundary';
import { datadogRum } from '@datadog/browser-rum';
import { captureExceptionsToSentry } from '~/helpers/exceptionHandler';

function EditorErrorFallbackView({
  resetErrorBoundary,
  style,
  error,
  inDrawer,
}: {
  error?: Error;
  resetErrorBoundary?: FallbackProps['resetErrorBoundary'];
  style?: React.CSSProperties;
  inDrawer?: boolean;
}) {
  useEffect(() => {
    if (error) {
      const context = {
        error,
        originatedUrl: window.location.pathname,
        url: window.location.pathname,
        pageCrashed: !inDrawer,
        inDrawer: !!inDrawer,
        newEditor: true,
      };
      datadogRum.addError(error, context);
      captureExceptionsToSentry(error, { pageCrashed: true });
    }
  }, [error, inDrawer]);

  return (
    <Box
      direction="column"
      alignItems="flex-start"
      gap={6}
      style={style || {
        padding: 'var(--cl-space-10)',
      }}
    >
      <Box direction="column" alignItems="flex-start" gap={2}>
        <Text as="h1" size={4} weight={500}>Something went wrong</Text>
        <Text as="h2" size={3} weight={400}>There was an issue while processing your action.{' '}
          Please report this issue to the team for further investigation.{' '}
          We regret this inconvenience.
        </Text>
      </Box>

      <Box direction="row" justifyContent="flex-start" gap={2}>
        {resetErrorBoundary && (
          <Button variant={ButtonVariant.secondary} onClick={() => { window.location.reload(); }}>
            Refresh page
          </Button>
        )}
      </Box>
    </Box>
  );
}

export default EditorErrorFallbackView;
